/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toolbar[_ngcontent-%COMP%]{background:#fff;border-radius:4px;display:flex;flex-direction:row}.toolbar--tools[_ngcontent-%COMP%]{box-shadow:0 1px 4px rgba(0,0,0,.3)}.toolbar__divider[_ngcontent-%COMP%]{height:100%;width:1px;background:#eaeff5}.toolbar-icon[_ngcontent-%COMP%]{display:inline-block;width:24px;margin-right:4px;text-align:center}"];
export { styles as styles };
